import { Post } from '../api/server';

export default function trackingLink(event, aff) {
  return Post('/affiliatetrackings', { event, aff });
}
